import { render, staticRenderFns } from "./subject-select.vue?vue&type=template&id=77430dfd"
import script from "./subject-select.vue?vue&type=script&lang=js"
export * from "./subject-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports